import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
// import './ReturningProject.css'; // Using inline styles instead

const ReturningProject = ({ onSubmit = () => {} }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate(); // Initialize navigation

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('Returning project credentials submitted:', { username, password });

    const formData = { username, password };
    onSubmit(formData);

    // Redirect to SpreadsheetProcessor page
    navigate('/spreadsheet');
  };

  return (
    <div className="returning-project-container" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f0f2f5',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div className="returning-project-card" style={{
        backgroundColor: '#ffffff',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <h2 style={{
          marginBottom: '8px',
          color: '#333',
          fontSize: '18px',
          textAlign: 'center'
        }}>Returning Project</h2>
        <p style={{
          marginBottom: '16px',
          color: '#666',
          fontSize: '14px',
          textAlign: 'center'
        }}>Please enter your API User credentials to continue.</p>
        <form onSubmit={handleSubmit}>
          <div className="input-group" style={{
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '16px'
          }}>
            <label style={{
              fontSize: '13px',
              fontWeight: 'bold',
              marginBottom: '4px',
              color: '#333'
            }}>Username:</label>
            <input 
              type="text" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)}
              style={{
                padding: '8px 12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px',
                transition: 'border-color 0.2s',
                outline: 'none'
              }}
              onFocus={(e) => e.target.style.borderColor = '#007bff'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
              required 
              placeholder="Enter your username"
            />
          </div>
          <div className="input-group" style={{
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '20px'
          }}>
            <label style={{
              fontSize: '13px',
              fontWeight: 'bold',
              marginBottom: '4px',
              color: '#333'
            }}>Password:</label>
            <input 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)}
              style={{
                padding: '8px 12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px',
                transition: 'border-color 0.2s',
                outline: 'none'
              }}
              onFocus={(e) => e.target.style.borderColor = '#007bff'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
              required 
              placeholder="Enter your password"
            />
          </div>
          <button 
            type="submit" 
            className="submit-btn"
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            Proceed
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReturningProject;